import { createMutations } from 'store/utils';

export default {
    ...createMutations('PARTNER_USERS'),
};
